/* ============================================
   Complete the Look v1.2 — Dirndl.com
   ============================================ */

function ctlVariantChange(select) {
  var wrapper = select.closest('.ctl-variant-selector');
  var btn = wrapper.querySelector('.ctl-btn');
  var val = select.value;
  if (val) {
    btn.dataset.variantId = val;
    btn.disabled = false;
    btn.classList.remove('ctl-btn--disabled');
  } else {
    btn.dataset.variantId = '';
    btn.disabled = true;
    btn.classList.add('ctl-btn--disabled');
  }
}

function ctlAddToCart(button) {
  var variantId = button.dataset.variantId;
  if (!variantId || button.disabled) return;

  var lang = (document.documentElement.lang || 'de').substring(0, 2);
  var l = lang === 'fr' ? 'fr' : lang === 'en' ? 'en' : 'de';

  var labelDef = { de: 'In den Warenkorb', en: 'Add to cart', fr: 'Ajouter au panier' };
  var labelAdded = { de: '\u2713 Hinzugef\u00fcgt', en: '\u2713 Added', fr: '\u2713 Ajout\u00e9' };
  var labelError = { de: 'Fehler', en: 'Error', fr: 'Erreur' };

  button.classList.add('is-loading');
  button.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    button.classList.remove('is-loading');

    if (data.status && data.status !== 200) {
      button.textContent = labelError[l];
      setTimeout(function() { button.textContent = labelDef[l]; }, 2500);
      return;
    }

    button.classList.add('is-added');
    button.textContent = labelAdded[l];

    ctlOpenCart();

    setTimeout(function() {
      button.classList.remove('is-added');
      button.textContent = labelDef[l];
    }, 3000);
  })
  .catch(function() {
    button.classList.remove('is-loading');
    button.textContent = labelError[l];
    setTimeout(function() { button.textContent = labelDef[l]; }, 2500);
  });
}

function ctlOpenCart() {
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  var drawer = document.querySelector('x-drawer[id*="cart"], .cart-drawer');
  if (drawer && typeof drawer.show === 'function') {
    drawer.show();
    return;
  }
  var cartBtn = document.querySelector('[href="/cart"], [data-action="open-cart"], .header__icon--cart button');
  if (cartBtn) { cartBtn.click(); }
}

document.addEventListener('DOMContentLoaded', function() {
  var tracks = document.querySelectorAll('.ctl-track');
  tracks.forEach(function(track) {
    var isDown = false;
    var startX, scrollLeft;
    track.addEventListener('mousedown', function(e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function() { isDown = false; });
    track.addEventListener('mouseup', function() { isDown = false; });
    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  });
});